<script lang="ts">
    
    import { fade } from 'svelte/transition';
    import { createEventDispatcher } from "svelte";
    import Button from "./Button.svelte";
    import { tweened } from 'svelte/motion';

    export let points: number;

    const dispatch = createEventDispatcher();
    const pointsTweened = tweened(0, {
        duration: 1000,
        interpolate: (a, b) => t => Math.floor((b - a) * t)
    });

    function onContinue(): void {
        dispatch('continue');
    }

    function onIntroend(): void {
        pointsTweened.set(points);
    }

</script>

<div class="fail-screen" transition:fade on:introend={onIntroend}>
    <img src="/images/fail.svg" alt="">
    <p class="text">La respuesta es incorrecta, fíjate bien la próxima vez que lo intentes...</p>
    <div class="points">
        <img src="/images/icon-points.svg" alt=""> -{$pointsTweened} puntos
    </div>
    <Button on:click={onContinue}>Continuar</Button>
</div>

<style lang="scss">

    .fail-screen {
        position: absolute;
        z-index: 10001;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vw);
        background-color: var(--color-fail);
        background-image: url('/images/activity-screen-background.svg');
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 15px;
    }

    .text {
        max-width: 260px;
        color: #fff;
        text-align: center;
        font-size: 1.3rem;
    }

    .points {
        display: flex;
        align-items: center;
        color: #fff;
        gap: 10px;
        font-size: 1.4rem;
        font-weight: bold;
        margin-bottom: 25px;
    }

</style>
